import React from 'react';

const ThirdPartySupportSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            他社で購入されたDJI機も修理対応
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            IDS佐賀教習所（本部）では、他の販売店や代理店で購入されたDJI製ドローンの修理も承ります。特にIDS佐賀教習所はDJI推薦修理センターに認定されており、保証期間内の製品であれば無償修理も対応可能です。
          </p>
        </div>

        <div className="bg-white rounded-lg p-8 shadow-sm">
          <h3 className="text-xl font-semibold text-gray-900 mb-6 text-center">
            対応可能な修理
          </h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                <div>
                  <span className="font-medium text-gray-900">保証期間内の製品起因故障：</span>
                  <span className="text-green-600 font-semibold">無償修理</span>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                <div>
                  <span className="font-medium text-gray-900">保証期間外の故障：</span>
                  <span className="text-blue-600 font-semibold">有償修理</span>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                <div>
                  <span className="font-medium text-gray-900">墜落・水没などユーザー起因の破損：</span>
                  <span className="text-blue-600 font-semibold">有償修理</span>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                <div>
                  <span className="font-medium text-gray-900">他社で購入された機体も対応</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-600 mb-6">
              お見積もりは無料です。まずは機体をお持ちいただき、DJI認定整備士による診断をお受けください。
            </p>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <div className="flex items-center justify-center mb-4">
                <i className="ri-award-line text-2xl text-blue-600 mr-3"></i>
                <h4 className="text-lg font-semibold text-gray-900">DJI推薦修理センター認定</h4>
              </div>
              <p className="text-gray-700">
                IDS佐賀教習所は、DJIから正式に推薦修理センターとして認定されています。
                DJIの厳格な基準をクリアした技術力と設備で、安心の修理サービスを提供いたします。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThirdPartySupportSection;